/* hs-eslint ignored failing-rules */

/* eslint-disable no-prototype-builtins */
'use es6';

import { combineReducers } from 'redux';
import produce from 'immer';
import Review from 'marketplace-ui-reviews/records/Review';
import ReviewStats from 'marketplace-ui-reviews/records/ReviewStats';
import ReviewFilters from 'marketplace-ui-reviews/records/ReviewFilters';
import * as ReviewTypes from 'marketplace-ui-reviews/constants/ReviewType';
import { PAGE_KEY } from 'marketplace-ui-reviews/constants/ReviewsListQueries';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import * as ActionTypes from '../../actions/ActionTypes';
const EMPTY_LIST = [];

const listRequestState = (state = RequestState.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_REVIEWS_REQUESTED:
      return RequestState.PENDING;

    case ActionTypes.PROFILE_REVIEWS_RECEIVED:
      return RequestState.SUCCEEDED;

    case ActionTypes.PROFILE_REVIEWS_FAILED:
      return RequestState.FAILED;

    case ActionTypes.PROFILE_REVIEWS_RESET:
      return RequestState.UNINITIALIZED;

    default:
      return state;
  }
};

const list = (state = EMPTY_LIST, action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_REVIEWS_RECEIVED:
      return Review.fromArray(action.payload.reviews);

    case ActionTypes.PROFILE_REVIEWS_RESET:
      return EMPTY_LIST;

    case ActionTypes.PROFILE_REVIEW_HELPFUL_RECEIVED:
      {
        const indexToUpdate = state.findIndex(review => review.get('id') === action.payload.reviewId);
        return produce(state, draftState => {
          draftState[indexToUpdate] = draftState[indexToUpdate].toggleHelpful(action.payload.reviewId, action.payload.userId, action.payload.isHelpful);
        });
      }

    default:
      return state;
  }
};

const total = (state = 0, action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_REVIEWS_RECEIVED:
      return action.payload.total;

    default:
      return state;
  }
};

const statsRequestState = (state = RequestState.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_REVIEW_STATS_REQUESTED:
      return RequestState.PENDING;

    case ActionTypes.PROFILE_REVIEW_STATS_RECEIVED:
      return RequestState.SUCCEEDED;

    case ActionTypes.PROFILE_REVIEW_STATS_FAILED:
      return RequestState.FAILED;

    case ActionTypes.PROFILE_REVIEW_STATS_RESET:
      return RequestState.UNINITIALIZED;

    default:
      return state;
  }
};

const stats = (state = new ReviewStats(), action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_REVIEW_STATS_RECEIVED:
      return new ReviewStats(action.payload).set('reviewType', ReviewTypes.PROFILE);

    default:
      return state;
  }
};

const filters = (state = new ReviewFilters(), action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_LISTING_RECEIVED:
      return new ReviewFilters({
        reviewTypes: [ReviewTypes.PROFILE],
        entityId: action.payload.id
      });

    case ActionTypes.PROFILE_REVIEW_FILTERS_UPDATED:
      {
        let newFilters = state.updateFilters(action.payload);

        if (!action.payload.hasOwnProperty(PAGE_KEY)) {
          newFilters = newFilters.updateFilters({
            [PAGE_KEY]: 1
          });
        }

        return newFilters;
      }

    case ActionTypes.PROFILE_REVIEW_FILTERS_RESET:
      return new ReviewFilters();

    default:
      return state;
  }
};

const reviewSubmitRequestState = (state = RequestState.UNINITIALIZED, action) => {
  switch (action.type) {
    case ActionTypes.PROFILE_REVIEW_SUBMIT_REQUESTED:
      return RequestState.PENDING;

    case ActionTypes.PROFILE_REVIEW_SUBMIT_RECEIVED:
      return RequestState.SUCCEEDED;

    case ActionTypes.PROFILE_REVIEW_SUBMIT_FAILED:
      return RequestState.FAILED;

    default:
      return state;
  }
};

export default combineReducers({
  listRequestState,
  list,
  statsRequestState,
  stats,
  total,
  filters,
  reviewSubmitRequestState
});